import React from 'react';

import BaseButton from '1_components/Buttons/BaseButton/BaseButton';
import useAudioRoutingStore from 'state/audioRoutingStore';

import S from './PlayPause.module.scss';

const PlayPause = () => {
  const { audioChunks, setIsPlaying, isPlaying } = useAudioRoutingStore();

  if (!audioChunks) return null;

  return (
    <BaseButton
      className={S.play_pause}
      onClick={() => setIsPlaying(!isPlaying)}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, ease: 'easeInOut' }}
    >
      {isPlaying ? (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.9165 17H11.0832V7H9.9165V17Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.9165 17H14.0832V7H12.9165V17Z"
            fill="white"
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 7.79756L15.1611 11.9999L9.5 16.2022L9.5 7.79756Z"
            stroke="white"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </BaseButton>
  );
};

export default PlayPause;
